import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-button',
	templateUrl:'./WaButtonPluginCompPage.html',
	styles: [],
	styleUrls:['./WaButtonPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaButtonPluginCompPage
{
	mdContent_1120 = `\`\`\`java
import com.jwebmp.webawesome.components.button.WaButton;
\`\`\``;
	mdContent_1121 = `\`\`\`java
new WaButton&lt;&gt;(String text, Variant variant)
\`\`\``;
	mdContent_1122 = `\`\`\`java
var btn = new WaButton<>("Click Me", Variant.Brand);
\`\`\``;
	mdContent_1123 = `\`\`\`java
var btn = new WaButton<>("Delete", Variant.Danger);
btn.setAppearance(Appearance.Outlined);
\`\`\``;
	mdContent_1124 = `\`\`\`java
var btn = new WaButton<>("Go Home", Variant.Neutral);
btn.addAttribute("[routerLink]", "['/home']");
\`\`\``;
}
